import { baseRoute } from '../../../constants/routes';

export const HATCH_GAME_ROUTE = baseRoute + '/start-hatch-game';

export const HATCH_GAME_ANSWER_ROUTE = baseRoute + '/answer-hatch-question';

export const SHARE_CHALLENGE_CALENDAR_ROUTE = baseRoute + '/share-challenge';

export const CALENDAR_PLAYER_SHARING = '/sharing/tags';

export const START_HATCH_GAME = 'START_HATCH_GAME';
export const START_HATCH_GAME_SUCCESS = 'START_HATCH_GAME_SUCCESS';

export const ANSWER_HATCH_QUESTION = 'ANSWER_HATCH_QUESTION';
export const ANSWER_HATCH_QUESTION_SUCCESS = 'ANSWER_HATCH_QUESTION_SUCCESS';

export const SET_HATCH_TIMER_VALUE = 'SET_HATCH_TIMER_VALUE';
export const SET_HATCH_TIMER_VALUE_SUCCESS = 'SET_HATCH_TIMER_VALUE_SUCCESS';

export const SET_HATCH_TIMER_OUT = 'SET_HATCH_TIMER_OUT';
export const SET_HATCH_TIMER_OUT_SUCCESS = 'SET_HATCH_TIMER_OUT_SUCCESS';

export const SHARE_CHALLENGE_CALENDAR = 'SHARE_CHALLENGE_CALENDAR';
export const SHARE_CHALLENGE_CALENDAR_SUCCESS = 'SHARE_CHALLENGE_CALENDAR_SUCCESS';
export const SET_CALENDAR_EVENT_AUDIO_VALUE = 'SET_CALENDAR_EVENT_AUDIO_VALUE';
export const SET_CALENDAR_EVENT_AUDIO_VALUE_SUCCESS = 'SET_CALENDAR_EVENT_AUDIO_VALUE_SUCCESS';

export const CLEAR_HATCHGAME_DATA = 'CLEAR_HATCHGAME_DATA';
export const CLEAR_HATCHGAME_DATA_SUCCESS = 'CLEAR_HATCHGAME_DATA_SUCCESS';

export const GET_CALENDAR_PLAYER_COVER = baseRoute + '/get-calendar-player-cover';